import styled from 'styled-components';
import { colors } from '../../constants';

export const ActionBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 8px 8px 16px;
  margin: 16px;
  height: 48px;
`;

export const ActionBarButton = styled.div`
  padding: 8px 16px 8px 0;
  display: flex;
  align-items: center;
  background-color: ${colors.white};
  cursor: pointer;
  > svg {
    margin-right: 8px;
  }
`;

export const ActionBarButtons = styled.div`
  display: flex;
  align-items: center;

  > svg {
    margin-left: 6px;
  }
`;
